import { BillPayRoute } from "route-components/BillPayRoute";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/p/$providerToken")({
    component: BillPayRoute,
});
